import type { FC } from "react";

import classNames from "classnames";

import { useMessageBus } from "@jti/fe-message-bus";

import { QuickLinks, QuickLinksGroup } from "../QuickLinks";

import { ListItem } from "./ListItem";
import type { ListItemAnchor } from "./types";
import { ListClickEvents } from "./types";

import styles from "./List.module.scss";

export type ListProps = {
  listItems: ListItemAnchor[];
  style: "standard" | "quick-links" | "navigation" | "navigation-horizontal";
  title?: string;
  listClickEvent: ListClickEvents;
  layout?: number;
  enableCookieSettings?: boolean;
};

export const List: FC<ListProps> = ({
  listItems,
  title,
  style = "standard",
  listClickEvent = ListClickEvents.ListClick,
  layout = 1,
  enableCookieSettings = false,
}) => {
  const messageBus = useMessageBus();

  const handleLinkClick = async () => {
    messageBus.publish("tracking.event", {
      payload: {
        event_name: listClickEvent,
      },
    });
  };
  if (style === "quick-links") {
    return (
      <QuickLinks>
        <QuickLinksGroup
          title={title ?? ""}
          categories={[
            {
              links: listItems.map((item) => ({ href: item.path ?? "", label: item.title, onClick: handleLinkClick })),
            },
          ]}
        ></QuickLinksGroup>
      </QuickLinks>
    );
  }

  return (
    <div
      className={classNames(styles.listWrapper)}
      style={{
        "--list-layout-columns-number": layout,
      }}
      data-testid="listWrapper"
    >
      {title && (
        <h3 className={styles.listTitle} data-testid="listTitle">
          {title}
        </h3>
      )}
      <ul
        className={classNames(styles.list, { [styles.listHorizontal]: style === "navigation-horizontal" })}
        data-testid="list"
      >
        {enableCookieSettings && <ListItem style={style} enableCookieSettings={enableCookieSettings} />}
        {listItems.map((item) => (
          <ListItem key={item.title} style={style} item={item} onClick={handleLinkClick} />
        ))}
      </ul>
    </div>
  );
};
